@if (!hideLabel) {
  <label
    for="typeahead"
    class="form-label">
    {{ label }}
  </label>
}
<ng-select
  id="typeahead"
  [attr.type]="FieldType.input"
  [formControl]="fieldControl"
  [placeholder]="placeholder"
  [multiple]="multiple"
  [closeOnSelect]="closeOnSelect"
  [searchable]="searchable"
  [clearable]="clearable"
  [maxSelectedItems]="maxLength"
  [readonly]="readonly"
  [ngClass]="getValidityClass()"
  [items]="(options | async) ?? []"
  bindLabel="option"
  bindValue="value">
  <ng-template
    ng-label-tmp
    let-item="item"
    let-clear="clear">
    <span class="ng-value-label"> {{ item.option }}</span>
    <span
      class="ng-value-icon right"
      (click)="clear(item)"
      (keydown.delete)="clear(item)"
      aria-hidden="true">
      ×
    </span>
  </ng-template>
</ng-select>
<bo-form-field-errors></bo-form-field-errors>
